/**
 * @generated SignedSource<<101e46124ec5df798a6464b6d18dafb9>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDetailItemInvoice_user$data = {
  readonly profile: {
    readonly email: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "PdpSharedDetailItemInvoice_user";
};
export type PdpSharedDetailItemInvoice_user$key = {
  readonly " $data"?: PdpSharedDetailItemInvoice_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailItemInvoice_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailItemInvoice_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "15f8fb941d3768e4629d3d9f397ae0f1";

export default node;
